import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Cierren35Service {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  getinfo(){
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    return infoUsu;

  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    console.log("Id empresa");
    console.log(this.idEmpresa);
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusCierre(anio: number){
    let datos: any = {fechaCertificar: anio,	close: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusCierre(anio: number){
    let datos: any = {fechaCertificar: anio,	close: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  getStatu( productoid:any, Idioma: any){
    let datos: any = {productoId: productoid, close:1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.getStatus + this.idEmpresa, datos);
  }

  saveStatus(idproducto: any){
    let datos: any = {productoId: idproducto,	close: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus + this.idEmpresa, datos);
  }

  closesurvey(productoId,typesurvey){
    let datos: any = { productoId: productoId, tipoEncuesta:typesurvey};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getsurveyclose + this.idEmpresa, datos);
  }

  getAvanceNorma(productoId,typesurvey,bandera?){

    let datos: any = { productoId: productoId, tipoEncuesta:typesurvey };
    if(bandera){
      console.log("Desde status encuesta");
      let idEmpresa= localStorage.getItem('idEmpresa_surveysatus');
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getsurveyclose + idEmpresa, datos);
    }else{
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getsurveyclose + this.idEmpresa, datos);
    }


  }

  getConteoNorma(datos,bandera?){
    if(bandera){
      console.log("Desde status encuesta");
      let idEmpresa= localStorage.getItem('idEmpresa_surveysatus');
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteos35 + idEmpresa, datos);
    }else{
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteos35 + this.idEmpresa, datos);
    }

  }

  getInfoCentros(fecha:number){
    let datos = {fechaNorma35:fecha};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + this.idEmpresa, datos);
  }

  getInfoCentrosTmp(fecha:number,bandera?){
    let datos = {fechaNorma35:fecha};
    //return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + this.idEmpresa, datos);
    if(bandera){
      console.log("Desde status encuesta");
      let idEmpresa= localStorage.getItem('idEmpresa_surveysatus');
      console.log( DATOS_API.url + DATOS_API.endpoints.infoCentros + idEmpresa, datos);
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + idEmpresa, datos);
    }else{
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.infoCentros + this.idEmpresa, datos);
    }
  }
  public getFechaLanzamiento35(data){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.shedule.getFechaLanzamiento+this.idEmpresa,data);
  }

  getReminders(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.RegistrarRecordatorio + this.idEmpresa, datos);
  }

  guardaStatusConfirmacion(datos){
  // let datos: any = {fechaCertificar: anio,	confirmacion: status};
  console.log(datos);
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.wizardEnc.sendStatus + this.idEmpresa, datos);

  }

}
